import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as NotificationService from '../../services/notification.service';

@Component({
  selector: 'backoffice-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotificationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: NotificationService.NotificationDialogData
  ) {}
}
